import { render } from "./SMTPConfiguration.vue?vue&type=template&id=141523de"
import script from "./SMTPConfiguration.vue?vue&type=script&lang=js"
export * from "./SMTPConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__